import React, { useEffect, useState } from "react";

import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import SideMenu from "./SideMenu";
import Header from "./Header";
import Footer from "./Footer";
import Logout from "./Logout";
import Accordion from "react-bootstrap/Accordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Pagination from "react-bootstrap/Pagination";
import { DownloadCsHistory, history } from "../Utilities/URLCONSTANTS";
import { GetApiHeaders, GetApiHeadersWithToken } from "../Utilities/NetworkUtilities";
import axios from "axios";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import moment from "moment";
import Loader from "../Utilities/Loader";
import Select from "react-select";
import { customStyles } from "../Utilities/utils";
import Swal from "sweetalert2";



const History = () => {
  const [loaderImage, setLoaderImage] = useState(
    require("../images/cs_loader.gif")
  );
  const [data, setData] = useState([]);
  const [returnHistory, setReturnHistory] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState('');


  const fetchData = async () => {
    const fetchApi = history;

    setIsLoading(true);

    try {
      const headers = await GetApiHeaders();

      // Pass selected history in request body
      const requestType = selectedHistory
        ? selectedHistory.toLowerCase()
        : "history";

      const requestBody = {
        requestType: requestType,
      };

      console.log("selectedHistory:", selectedHistory);
      console.log("requestBody:", requestBody);

      const response = await axios.post(
        fetchApi,
        requestBody,
        { headers }
      );

      console.log("History Response:", response);

      if (response.data.response.requestsHistory) {
        setData(
          response.data.response.requestsHistory
        );

        console.log(
          "requestsHistory",
          response.data.response.requestsHistory
        );
      } else {
        setData([]);
      }

      if (response.data.response.returnsHistory) {
        console.log(
          "returnsHistory",
          response.data.response.returnsHistory
        );

        setReturnHistory(
          response.data.response.returnsHistory
        );
      } else {
        setReturnHistory([]);
      }
    } catch (error) {
      console.error(
        "Error fetching data:",
        error
      );

      setData([]);
      setReturnHistory([]);
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchData();
  //   console.log("selectedHistory", selectedHistory);
  // }, [selectedHistory]);

  useEffect(() => {
    fetchData();
    console.log(
      "selectedHistory",
      selectedHistory
    );
  }, [selectedHistory]);




  const handleDownload = async () => {
    const downloadApi = DownloadCsHistory;

    try {
      setIsLoading(true);

      const headers = await GetApiHeaders();

      // Get file server authentication code
      const fileServerAuthCode =
        await GetApiHeadersWithToken();

      // If nothing is selected, send "history"
      const requestType = selectedHistory
        ? selectedHistory.toLowerCase()
        : "history";

      // Pass selected value in request object
      const requestBody = {
        requestType: requestType,
      };

      console.log("Selected History:", selectedHistory);
      console.log("Request Body:", requestBody);

      const response = await axios.post(
        downloadApi,
        requestBody,
        {
          headers: {
            ...headers,
            fileServerAuthCode: fileServerAuthCode,
          },
        }
      );

      console.log(
        "Download Response:",
        response.data
      );

      let fileUrl = "";

      if (requestType === "history") {
        fileUrl =
          response.data?.response?.history;
      } else if (requestType === "request") {
        fileUrl =
          response.data?.response?.returns;
      } else if (requestType === "return") {
        fileUrl =
          response.data?.response?.returns;
      }

      // If API returns a message instead of a URL
      if (
        fileUrl &&
        !fileUrl.startsWith("http")
      ) {
        Swal.fire({
          icon: "warning",
          title: "No Data Available",
          text: "No Data Available",
          confirmButtonColor: "#4A7729",
        });

        return;
      }

      if (fileUrl) {
        console.log("File URL:", fileUrl);

        // Fetch file from Media API as Blob
        const fileResponse = await axios.get(
          fileUrl,
          {
            headers: {
              fileServerAuthCode:
                fileServerAuthCode,
            },
            responseType: "blob",
          }
        );

        console.log(
          "File Response:",
          fileResponse
        );

        // Create Blob URL
        const blobUrl = URL.createObjectURL(
          fileResponse.data
        );

        // Get file name from imagePath
        const url = new URL(fileUrl);

        const imagePath =
          url.searchParams.get("imagePath");

        const fileName =
          imagePath?.split("/").pop() ||
          "download.xlsx";

        console.log(
          "Downloading File:",
          fileName
        );

        // Create download link
        const link =
          document.createElement("a");

        link.href = blobUrl;
        link.download = fileName;

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);

        // Release Blob URL
        setTimeout(() => {
          URL.revokeObjectURL(blobUrl);
        }, 100);
      } else {
        console.error(
          "No Data Available:",
          response.data
        );

        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "No Data Available.",
          confirmButtonColor: "#4A7729",
        });
      }
    } catch (error) {
      console.error(
        "Error fetching data:",
        error
      );

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while downloading.",
        confirmButtonColor: "#4A7729",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const historyOptions = [
    { value: "Request", label: "Request" },
    { value: "Return", label: "Return" },
  ];

  return (
    <body id="page-top">
      <div id="wrapper">
        <SideMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div>
              <div className="container-fluid">
                <div className="card border-0">
                  <h5 className="Roles_text">History</h5>
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
                    {/* History Dropdown */}

                    <div
                      className="history-dropdown"
                      style={{ width: "250px", minWidth: "220px" }}
                    >
                      <Select
                        styles={{
                          ...customStyles,
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        menuPortalTarget={document.body}
                        options={historyOptions}
                        placeholder="Select History"
                        value={
                          historyOptions.find(
                            (option) => option.value === selectedHistory
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setSelectedHistory(selectedOption?.value || "")
                        }
                      />
                    </div>

                    {/* Download Button */}
                    <button
                      className="btn btn-primary"
                      onClick={handleDownload}
                      disabled={isLoading}
                      style={{
                        minWidth: "120px",
                        height: "38px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {isLoading ? "Downloading..." : "Download"}
                    </button>
                  </div>

                  <div className="card data_tableCard">
                    <div
                      className="card-body"
                      style={{ overflowX: "auto" }}
                    >
                      <Table>
                        <Thead>
                          <Tr>
                            <Th className="pl-1 preventive-header">S.No</Th>
                            <Th className="text-center p-2 preventive-header">
                              History
                            </Th>
                          </Tr>
                        </Thead>

                        <Tbody>
                          {selectedHistory == "Request" &&
                            data.map((item, index) => {
                              var newDateFormat = moment(item.submittedDate).format("DD-MMM-YYYY hh:mm:ss A");
                              var productRequiredDate = moment(
                                item.productRequiredDate
                              ).format("DD-MMM-YYYY");
                              var productIssuedDate = moment(
                                item.productIssuedDate
                              ).format("DD-MMM-YYYY");
                              return (
                                <Tr key={index}>
                                  <Td className="pl-1">{index + 1}</Td>
                                  <Td>
                                    <Accordion
                                      defaultActiveKey="0"
                                      className="acc mt-2 mr-1"
                                      id="dns"
                                    >
                                      <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                          <div
                                            key={index}
                                            className="accordion-header-row"
                                            style={{ fontSize: 14 }}
                                          >
                                            {/* Request ID */}
                                            <div className="header-field">
                                              <span className="header-label">Request ID</span>
                                              <span className="header-colon">:</span>
                                              <span className="header-value">{item.requestId}</span>
                                            </div>

                                            {/* Requester Name */}
                                            <div className="header-field">
                                              <span className="header-label">Requester Name</span>
                                              <span className="header-colon">:</span>
                                              {/* <span className="header-value">{item.requesterName}</span> */}
                                              <span className="header-value">
                                                {item.requesterName
                                                  ?.toLowerCase()
                                                  .replace(/\b\w/g, (char) => char.toUpperCase())}{" "}
                                              </span>
                                            </div>

                                            {/* On Behalf Of */}
                                            {item.requestSelfOthers?.toLowerCase() !== "self" &&
                                              item.requestSelfOthers &&
                                              item.acceptorName ? (
                                              <div className="header-field">
                                                <span className="header-label">On Behalf Of</span>
                                                <span className="header-colon">:</span>
                                                <span className="header-value">
                                                  {/* {item.employeeName} */}
                                                  {item.employeeName
                                                    ?.toLowerCase()
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())}
                                                </span>
                                              </div>
                                            ) : (
                                              <div></div>
                                            )}

                                            {/* Status */}
                                            <div className="header-field">
                                              <span className="header-label">Status</span>
                                              <span className="header-colon">:</span>

                                              <span className="header-value">
                                                {item.requestStatusCode === 2 ? (
                                                  <span style={{ color: "#4A7729", fontWeight: 600 }}>
                                                    Accepted
                                                  </span>
                                                ) : item.requestStatusCode === 3 ? (
                                                  <span style={{ color: "#D50101", fontWeight: 600 }}>
                                                    Rejected
                                                  </span>
                                                ) : item.requestStatusCode === 0 ? (
                                                  <span style={{ color: "orange", fontWeight: 600 }}>
                                                    Pending
                                                  </span>
                                                ) : (
                                                  <span style={{ color: "orange", fontWeight: 600 }}>
                                                    Partially Accept
                                                  </span>
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                          <div className="">
                                            {item.productCategories.map(
                                              (category, pcIndex) => {
                                                return (
                                                  <div className="request-card mt-3">
                                                    <div className="mt-3">
                                                      <div className="d-flex gap-4 align-items-center mb-3">
                                                        <p style={{ fontSize: 16 }} className="mb-0">
                                                          <b
                                                            style={{
                                                              fontSize: 18,
                                                              color: "orange",
                                                            }}
                                                          >
                                                            Category{" "}
                                                          </b>{" "}
                                                          <span
                                                            style={{
                                                              marginLeft: 47,
                                                            }}
                                                          >
                                                            :{" "}
                                                          </span>{" "}
                                                          &nbsp;
                                                          {category.categoryName}
                                                        </p>

                                                        <div style={{ fontSize: 14, width: "100%", }} className="ProductNameForRandM d-flex"   >
                                                          <span style={{ width: '33.4%' }}>
                                                            <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                              Request Date&Time
                                                            </span>
                                                            <span >  :&nbsp;
                                                            </span>
                                                            <span style={{ width: '64%', display: 'inline-block' }}>{newDateFormat}</span>
                                                          </span>
                                                        </div>
                                                      </div>
                                                      {category.products.map(
                                                        (
                                                          product,
                                                          productIndex
                                                        ) => {
                                                          return (
                                                            <>
                                                              <div style={{ fontSize: 14, width: "100%", }}
                                                                className="ProductNameForRandM d-flex mt-3" key={productIndex}>
                                                                <span style={{ width: '33.4%' }}>
                                                                  <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                    Product  Name
                                                                  </span>
                                                                  <span >  :&nbsp;
                                                                  </span>
                                                                  <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{product.productName}</span>
                                                                </span>
                                                                <span style={{ width: '33.4%' }}>
                                                                  <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                    Required  Quantity
                                                                  </span>
                                                                  <span >  :&nbsp;
                                                                  </span>
                                                                  <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{product.productRequiredQuantity}</span>
                                                                </span>
                                                                <span style={{ width: '33.4%' }}>
                                                                  <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                    Required  Location
                                                                  </span>
                                                                  <span >  :&nbsp;
                                                                  </span>
                                                                  <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.productRequiredLocation}</span>
                                                                </span>
                                                              </div>
                                                              <div style={{ fontSize: 14, width: "100%", }}
                                                                className="ProductNameForRandM d-flex mt-3" >
                                                                {
                                                                  item.requestStatusCode === 3 ? "" : (
                                                                    <span style={{ width: '33.4%' }}>
                                                                      <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                        Issued Quantity
                                                                      </span>
                                                                      <span >  :&nbsp;
                                                                      </span>
                                                                      <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{product.issuedQuantity}</span>
                                                                    </span>
                                                                  )
                                                                }
                                                                <span style={{ width: '33.4%' }}>
                                                                  <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                    Issued By
                                                                  </span>
                                                                  <span >  :&nbsp;
                                                                  </span>
                                                                  <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.acceptorName}</span>
                                                                </span>
                                                                <span style={{ width: '33.4%' }}>
                                                                  <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                    Total Order Value
                                                                  </span>
                                                                  <span >  :&nbsp;
                                                                  </span>
                                                                  <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.totalOrderValue}</span>
                                                                </span>
                                                              </div>
                                                              <div style={{ fontSize: 14, width: "100%", }}
                                                                className="ProductNameForRandM d-flex mt-3" >
                                                                <span style={{ width: '33.4%' }}>
                                                                  <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                    Unit Price
                                                                  </span>
                                                                  <span >  :&nbsp;
                                                                  </span>
                                                                  <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{product.productUnitPrice}</span>
                                                                </span>
                                                                <span style={{ width: '33.4%' }}>
                                                                  <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                    Request Type
                                                                  </span>
                                                                  <span >  :&nbsp;
                                                                  </span>
                                                                  <span style={{ width: '64%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.requestSelfOthers}</span>
                                                                </span>

                                                                {item.requestStatusCode !== 3 &&
                                                                  item.productIssuedDate &&
                                                                  item.productIssuedDate !== "null" && (
                                                                    <span style={{ width: "33.4%" }}>
                                                                      <span
                                                                        style={{
                                                                          width: "40%",
                                                                          display: "inline-block",
                                                                          fontWeight: 600,
                                                                        }}
                                                                      >
                                                                        Delivery Date
                                                                      </span>
                                                                      <span>:&nbsp;</span>
                                                                      <span
                                                                        style={{
                                                                          width: "60%",
                                                                          display: "inline-flex",
                                                                          whiteSpace: "break-spaces",
                                                                        }}
                                                                      >
                                                                        {item.productIssuedDate}
                                                                      </span>
                                                                    </span>
                                                                  )}
                                                              </div>
                                                              <div style={{ fontSize: 14, width: "100%", }}
                                                                className="ProductNameForRandM d-flex mt-3" >

                                                                {item.requestStatusCode === 3 ? ("") : (
                                                                  <span style={{ width: '33.4%' }}>
                                                                    <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                      Required  Date
                                                                    </span>
                                                                    <span >  :&nbsp;
                                                                    </span>
                                                                    <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{productRequiredDate}</span>
                                                                  </span>
                                                                )}
                                                                {item.requesterRemarks !== '' ? (
                                                                  <span style={{ width: '33.4%' }}>
                                                                    <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                      Requester Remarks
                                                                    </span>
                                                                    <span >  :&nbsp;
                                                                    </span>
                                                                    {/* <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.requestorRemarks}</span> */}
                                                                    <span
                                                                      style={{
                                                                        width: "60%",
                                                                        display: "inline-flex",
                                                                        whiteSpace: "normal",
                                                                        overflowWrap: "anywhere",
                                                                        wordBreak: "break-word",
                                                                      }}
                                                                    >
                                                                      {item.requestorRemarks}
                                                                    </span>
                                                                  </span>
                                                                ) : ''
                                                                }
                                                                {
                                                                  item.acceptorRemarks !== '' ? (
                                                                    <span style={{ width: '33.4%' }}>
                                                                      <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                        Acceptor Remarks
                                                                      </span>
                                                                      <span >  :&nbsp;
                                                                      </span>
                                                                      {/* <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.accepterRemarks}</span> */}
                                                                      <span
                                                                        style={{
                                                                          width: "60%",
                                                                          display: "inline-flex",
                                                                          whiteSpace: "normal",
                                                                          overflowWrap: "anywhere",
                                                                          wordBreak: "break-word",
                                                                        }}
                                                                      >
                                                                        {item.accepterRemarks}
                                                                      </span>
                                                                    </span>) : ''
                                                                }
                                                              </div>
                                                            </>
                                                          );
                                                        }
                                                      )}
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            )}
                                          </div>
                                          <div
                                            style={{ fontSize: 14 }}
                                            className="mt-2 ml-3"
                                          ></div>
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    </Accordion>
                                  </Td>
                                </Tr>
                              );
                            })
                          }
                          {selectedHistory == "Return" &&
                            returnHistory.map((item, index) => {
                              var newDateFormat = moment(item.submittedDate).format("DD-MMM-YYYY hh:mm:ss A");
                              var productRequiredDate = moment(
                                item.productRequiredDate
                              ).format("DD-MMM-YYYY");
                              var productIssuedDate = moment(
                                item.productIssuedDate
                              ).format("DD-MMM-YYYY");
                              return (
                                <Tr key={index}>
                                  <Td className="pl-1">{index + 1}</Td>
                                  <Td>
                                    <Accordion
                                      defaultActiveKey="0"
                                      className="acc mt-2 mr-1"
                                      id="dns"
                                    >
                                      <Accordion.Item eventKey="1">
                                        {/* <Accordion.Header>
                                          <div
                                            key={index}
                                            className="ProductName d-flex"
                                            style={{
                                              fontSize: 14,
                                              width: "100%",
                                              gap: "30px",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <span
                                              style={{
                                                width: "20%",
                                                display: "flex",
                                                alignItems: "flex-start",
                                              }}
                                            >
                                              <b
                                                style={{
                                                  minWidth: "90px",
                                                  fontWeight: 600,
                                                  flexShrink: 0,
                                                }}
                                              >
                                                Request ID
                                              </b>
                                              <span
                                                style={{
                                                  margin: "0 6px",
                                                  flexShrink: 0,
                                                }}
                                              >
                                                :
                                              </span>
                                              <span
                                                style={{
                                                  wordBreak: "break-word",
                                                  overflowWrap: "break-word",
                                                  whiteSpace: "normal",
                                                  flex: 1,
                                                }}
                                              >
                                                {item.requestId}
                                              </span>
                                            </span>
                                            <span
                                              style={{
                                                width: "33%",
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <b
                                                style={{
                                                  minWidth: "150px",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                Returner Name
                                              </b>
                                              <span style={{ margin: "0 8px" }}>:</span>
                                              <span
                                                style={{
                                                  wordBreak: "break-word",
                                                  overflowWrap: "break-word",
                                                  whiteSpace: "normal",
                                                  flex: 1,
                                                }}
                                              >
                                                <span>
                                                  {item.returnerName
                                                    ?.toLowerCase()
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())}{" "}
                                                </span>
                                              </span>
                                            </span>
                                            {
                                              item.requestSelfOthers?.toLowerCase() !== "self" &&
                                              item.requestSelfOthers &&
                                              item.acceptorName && (
                                                <span
                                                  style={{
                                                    width: "29%",
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <b
                                                    style={{
                                                      minWidth: "110px",
                                                      flexShrink: 0,
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    On Behalf Of
                                                  </b>
                                                  <span
                                                    style={{
                                                      margin: "0 6px",
                                                      flexShrink: 0,
                                                    }}
                                                  >
                                                    :
                                                  </span>
                                                  <span
                                                    style={{
                                                      flex: 1,
                                                      minWidth: 0,
                                                      wordBreak: "break-word",
                                                      overflowWrap: "anywhere",
                                                      whiteSpace: "normal",
                                                    }}
                                                  >
                                                    {item.employeeName
                                                      ?.toLowerCase()
                                                      .replace(/\b\w/g, (char) => char.toUpperCase())}
                                                  </span>
                                                </span>
                                              )
                                            }
                                            <span
                                              className=""
                                              style={{ width: "18%" }}
                                            >
                                              <b>
                                                Status &nbsp; &nbsp;: &nbsp;
                                              </b>
                                              <span>
                                                {item.requestStatusCode ===
                                                  2 ? (
                                                  <span
                                                    style={{
                                                      color: "#4A7729",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    Accepted
                                                  </span>
                                                ) : item.requestStatusCode ===
                                                  3 ? (
                                                  <span
                                                    style={{
                                                      color: "#D50101", fontWeight: 600,
                                                    }}
                                                  >
                                                    Rejected
                                                  </span>
                                                ) : item.requestStatusCode ===
                                                  0 ? (
                                                  <span
                                                    style={{
                                                      color: "Orange",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    Pending
                                                  </span>
                                                ) : (
                                                  <span
                                                    style={{
                                                      color: "orange",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    Partially Accept
                                                  </span>
                                                )}
                                              </span>
                                              &nbsp; &nbsp;
                                            </span>

                                          </div>
                                        </Accordion.Header> */}

                                        <Accordion.Header>
                                          <div
                                            key={index}
                                            className="accordion-header-row"
                                            style={{ fontSize: 14 }}
                                          >
                                            {/* Request ID */}
                                            <div className="header-field">
                                              <span className="header-label">Request ID</span>
                                              <span className="header-colon">:</span>
                                              <span className="header-value">{item.requestId}</span>
                                            </div>

                                            {/* Returner Name */}
                                            <div className="header-field">
                                              <span className="header-label">Returner Name</span>
                                              <span className="header-colon">:</span>
                                              <span className="header-value">
                                                {item.returnerName
                                                  ?.toLowerCase()
                                                  .replace(/\b\w/g, (char) => char.toUpperCase())}
                                              </span>
                                            </div>

                                            {/* On Behalf Of */}
                                            {item.requestSelfOthers?.toLowerCase() !== "self" &&
                                              item.requestSelfOthers &&
                                              item.acceptorName ? (
                                              <div className="header-field">
                                                <span className="header-label">On Behalf Of</span>
                                                <span className="header-colon">:</span>
                                                <span className="header-value">
                                                  {item.employeeName
                                                    ?.toLowerCase()
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())}
                                                </span>
                                              </div>
                                            ) : (
                                              <div></div>
                                            )}

                                            {/* Status */}
                                            <div className="header-field">
                                              <span className="header-label">Status</span>
                                              <span className="header-colon">:</span>

                                              <span className="header-value">
                                                {item.requestStatusCode === 2 ? (
                                                  <span style={{ color: "#4A7729", fontWeight: 600 }}>
                                                    Accepted
                                                  </span>
                                                ) : item.requestStatusCode === 3 ? (
                                                  <span style={{ color: "#D50101", fontWeight: 600 }}>
                                                    Rejected
                                                  </span>
                                                ) : item.requestStatusCode === 0 ? (
                                                  <span style={{ color: "orange", fontWeight: 600 }}>
                                                    Pending
                                                  </span>
                                                ) : (
                                                  <span style={{ color: "orange", fontWeight: 600 }}>
                                                    Partially Accept
                                                  </span>
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                          <div className="">
                                            {item.productCategories.map(
                                              (category, pcIndex) => {
                                                return (
                                                  <div className="request-card mt-3">
                                                    <div className="mt-3">
                                                      <div className="d-flex gap-4 align-items-center mb-3">

                                                        <p style={{ fontSize: 16 }} className="mb-0">
                                                          <b
                                                            style={{
                                                              fontSize: 18,
                                                              color: "orange",
                                                            }}
                                                          >
                                                            Category{" "}
                                                          </b>{" "}
                                                          <span
                                                            style={{
                                                              marginLeft: 47,
                                                            }}
                                                          >
                                                            :{" "}
                                                          </span>{" "}
                                                          &nbsp;
                                                          {category.categoryName}
                                                        </p>

                                                        <div style={{ fontSize: 14, width: "100%", }} className="ProductNameForRandM d-flex"   >
                                                          <span style={{ width: '33.4%' }}>
                                                            <span style={{ width: '50%', display: 'inline-block', fontWeight: 600 }} >
                                                              Returned Date&Time
                                                            </span>
                                                            <span >  :&nbsp;
                                                            </span>
                                                            <span style={{ width: '64%', display: 'inline-block' }}>{newDateFormat}</span>
                                                          </span>
                                                        </div>
                                                      </div>
                                                      {category.products.map(
                                                        (
                                                          product,
                                                          productIndex
                                                        ) => {
                                                          return (
                                                            <>
                                                              <div style={{ fontSize: 14, width: "100%", }}
                                                                className="ProductNameForRandM d-flex mt-3" key={productIndex}>
                                                                <span style={{ width: '33.4%' }}>
                                                                  <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                    Product Name
                                                                  </span>
                                                                  <span >  :&nbsp;
                                                                  </span>
                                                                  {/* <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{product.productName}</span> */}
                                                                  <span
                                                                    style={{
                                                                      width: "60%",
                                                                      display: "inline-block",
                                                                      whiteSpace: "normal",
                                                                      wordBreak: "break-word",
                                                                      overflowWrap: "anywhere",
                                                                      verticalAlign: "top",
                                                                    }}
                                                                  >
                                                                    {product.productName}
                                                                  </span>
                                                                </span>


                                                                <span style={{ width: '33.4%' }}>
                                                                  <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                    Required  Quantity
                                                                  </span>
                                                                  <span >  :&nbsp;
                                                                  </span>
                                                                  <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{product.productRequiredQuantity}</span>
                                                                </span>
                                                                <span style={{ width: '33.4%' }}>
                                                                  <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                    Returned  Location
                                                                  </span>
                                                                  <span >  :&nbsp;
                                                                  </span>
                                                                  <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.productReturnedLocation}</span>
                                                                </span>
                                                              </div>

                                                              <div style={{ fontSize: 14, width: "100%", }}
                                                                className="ProductNameForRandM d-flex mt-3" >
                                                                {
                                                                  item.requestStatusCode === 3 ? "" : (
                                                                    <span style={{ width: '33.4%' }}>
                                                                      <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                        Issued Quantity
                                                                      </span>
                                                                      <span >  :&nbsp;
                                                                      </span>
                                                                      <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{product.issuedQuantity}</span>
                                                                    </span>
                                                                  )
                                                                }

                                                                <span style={{ width: '33.4%' }}>
                                                                  <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                    Total Order Value
                                                                  </span>
                                                                  <span >  :&nbsp;
                                                                  </span>
                                                                  <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.totalOrderValue}</span>
                                                                </span>
                                                              </div>
                                                              <div style={{ fontSize: 14, width: "100%", }}
                                                                className="ProductNameForRandM d-flex mt-3" >
                                                                <span style={{ width: '33.4%' }}>
                                                                  <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                    Unit Price
                                                                  </span>
                                                                  <span >  :&nbsp;
                                                                  </span>
                                                                  <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{product.productUnitPrice}</span>
                                                                </span>

                                                              </div>
                                                              <div style={{ fontSize: 14, width: "100%", }}
                                                                className="ProductNameForRandM d-flex mt-3" >
                                                                {
                                                                  item.requestorRemarks !== '' ? (
                                                                    <span style={{ width: '33.4%' }}>
                                                                      <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                        Requester Remarks
                                                                      </span>
                                                                      <span >  :&nbsp;
                                                                      </span>
                                                                      <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.requestorRemarks}</span>
                                                                    </span>) : ''
                                                                }
                                                                {
                                                                  item.acceptorRemarks !== '' ? (
                                                                    <span style={{ width: '33.4%' }}>
                                                                      <span style={{ width: '40%', display: 'inline-block', fontWeight: 600 }} >
                                                                        Acceptor Remarks
                                                                      </span>
                                                                      <span >  :&nbsp;
                                                                      </span>
                                                                      <span style={{ width: '60%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.acceptorRemarks}</span>
                                                                    </span>) : ''
                                                                }
                                                              </div>
                                                            </>
                                                          );
                                                        }
                                                      )}
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            )}
                                          </div>
                                          <div
                                            style={{ fontSize: 14 }}
                                            className="mt-2 ml-3"
                                          ></div>
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    </Accordion>
                                  </Td>
                                </Tr>
                              );
                            })
                          }
                        </Tbody>
                      </Table>
                      {isLoading && (
                        <Loader
                          loading={isLoading}
                          message={"Fetching Data. Please Wait..!"}
                          loderimage={loaderImage}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>

      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
      <Logout />
    </body>
  );
};
export default History;
